export default "__VITE_ASSET__YrBm3loJ__"